import { APOLLO_OPTIONS } from 'apollo-angular';
import { InMemoryCache, ApolloClientOptions } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';

function getGraphqlUri(): string {
  return localStorage.getItem('appSyncUrl') || '';
}

/**
 * Factory creating the Apollo Client options
 *   objects are normalized by `Key`. This makes cache.modify/update on one instance
 *   propagate to every query embedding that object.
 */
export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
  return {
    link: httpLink.create({ uri: getGraphqlUri() }),
    cache: new InMemoryCache({
      typePolicies: {
        // Each entry tells Apollo: use field "Key" as the unique identifier.
        Release: { keyFields: ['Key'] },
        ApplicationVersion: {
          keyFields: ['Key'],
          fields: {
            Environment: { merge: true }
          }
        },
        Deployment: {
          keyFields: ['Key'],
          fields: {
            DepManifest: { merge: true }
          }
        },
        Environment: { keyFields: ['Id'] },
        Account: { keyFields: ['AccountID'] },

        // Field merge policies on Query
        Query: {
          fields: {
            listApplicationVersions: {
              keyArgs: ['AppID'],
              merge(existing = [], incoming) {
                return incoming;
              }
            },

            // if we overwrite the whole applications list
            listApplications: {
              merge(existing = [], incoming) {
                return incoming;
              }
            },

            // Separate cache slots for filtered variants (SOURCE/TARGET/unfiltered)
            listEnvironments: {
              keyArgs: ['Input', ['Filter', ['Type']]],
              merge(existing = [], incoming) {
                return incoming;
              }
            }
          }
        }
      }
    })
  };
}

/**
 * Angular will call createApollo injecting HttpLink
 */
export const APOLLO_PROVIDER = {
  provide: APOLLO_OPTIONS,
  useFactory: createApollo,
  deps: [HttpLink]
};
